document.addEventListener("DOMContentLoaded", function () {
  const slider = document.querySelector(".slider-1");
  const handle = document.querySelector(".slider-handle");
  const afterImage = document.querySelector(".after");
  const beforeLabel = document.querySelector(".before-label");
  const afterLabel = document.querySelector(".after-label");
  const beforeAfterMainContainer = document.querySelector("#product-before-after-slider-container");


  let isDragging = false;

  // Initialize slider position
  function initSlider() {
    const sliderRect = slider.getBoundingClientRect();
    const initialPosition = sliderRect.width / 2;
    handle.style.left = `${initialPosition}px`;
    afterImage.style.clipPath = `inset(0 0 0 ${initialPosition}px)`;
  }

  // Update label clipping based on handle position
  function updateLabelClipping(handlePosition) {
    const sliderRect = slider.getBoundingClientRect();
    const beforeLabelRect = beforeLabel.getBoundingClientRect();
    const afterLabelRect = afterLabel.getBoundingClientRect();

    // Calculate how much of each label should be visible
    const beforeVisibleWidth = handlePosition - beforeLabelRect.left;
    const afterVisibleWidth = afterLabelRect.right - handlePosition;

    // Apply clipping to labels
    beforeLabel.style.clipPath = `inset(0 ${Math.max(
      0,
      beforeLabelRect.width - beforeVisibleWidth
    )}px 0 0)`;
    afterLabel.style.clipPath = `inset(0 0 0 ${Math.max(
      0,
      afterLabelRect.width - afterVisibleWidth
    )}px)`;
  }

  // Mouse events
  handle.addEventListener("mousedown", (e) => {
    isDragging = true;
    document.body.style.cursor = "ew-resize";
    e.preventDefault();
  });

  beforeAfterMainContainer.addEventListener("mouseup", () => {
    isDragging = false;
    document.body.style.cursor = "";
  });

  beforeAfterMainContainer.addEventListener("mousemove", (e) => {
    if (isDragging) {
      const sliderRect = slider.getBoundingClientRect();
      let offsetX = e.clientX - sliderRect.left;

      // Constrain to slider boundaries
      offsetX = Math.max(0, Math.min(offsetX, sliderRect.width));

      handle.style.left = `${offsetX}px`;
      afterImage.style.clipPath = `inset(0 0 0 ${offsetX}px)`;
      updateLabelClipping(e.clientX);
    }
  });

  // Click events for desktop
  beforeAfterMainContainer.addEventListener("click", (e) => {
    const sliderRect = slider.getBoundingClientRect();
    let offsetX = e.clientX - sliderRect.left;

    // Constrain to slider boundaries
    offsetX = Math.max(0, Math.min(offsetX, sliderRect.width));

    handle.style.left = `${offsetX}px`;
    afterImage.style.clipPath = `inset(0 0 0 ${offsetX}px)`;
    updateLabelClipping(e.clientX);
  });

  // Touch events for mobile
  handle.addEventListener("touchstart", (e) => {
    isDragging = true;
    e.preventDefault();
  });

  beforeAfterMainContainer.addEventListener("touchend", () => {
    isDragging = false;
  });

  beforeAfterMainContainer.addEventListener("touchmove", (e) => {
    if (isDragging) {
      const sliderRect = slider.getBoundingClientRect();
      let offsetX = e.touches[0].clientX - sliderRect.left;

      offsetX = Math.max(0, Math.min(offsetX, sliderRect.width));

      handle.style.left = `${offsetX}px`;
      afterImage.style.clipPath = `inset(0 0 0 ${offsetX}px)`;
      updateLabelClipping(e.touches[0].clientX);
      e.preventDefault();
    }
  });

  // Initialize on load and on resize
  initSlider();
  window.addEventListener("resize", initSlider);
});
